<template>
  <div>
    <main-header v-if="authorised" />
    <v-preloader v-show="loading" />
    <router-view :key="$route.fullPath"/>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import MainHeader from "@/components/MainHeader";
import VPreloader from "@/components/VPreloader";


export default {
  name: "LayoutAuthorized",

  components: {
    MainHeader,
    VPreloader
  },

  computed: {
    ...mapGetters({
      loading: "isLoading",
      authorised: "authorization/loggedIn"
    })
  }
};
</script>
